import { SCREENS } from '@white-label-configuration/constants';
const isMobileResolution = (): boolean => {
  return window.innerWidth < SCREENS.MD;
};

export const pushModalState = function(nameOfModal: string): void {
  if (!isMobileResolution()) return;

  if (!history.state?.nameOfModal?.includes(nameOfModal)) {
    history.pushState({ nameOfModal }, 'Popup');
  }
};

export const popstateEventHandler = function(
  nameOfModal: string,
  callback: () => void
): (() => void) | null {
  if (!isMobileResolution()) return null;

  const onPopstate = (event: PopStateEvent) => {
    if (!(event.state?.nameOfModal?.includes(nameOfModal))) {
      callback();
    }
  };

  window.addEventListener('popstate', onPopstate);

  return () => {
    window.removeEventListener('popstate', onPopstate);
  };
};

export const closeModal = function(nameOfModal: string): void {
  if (!isMobileResolution()) return;

  if (history.state?.nameOfModal && history.state.nameOfModal.includes(nameOfModal)) {
    const currentState = history.state ?? {};
    const newState = { ...currentState };
    delete newState.nameOfModal;
    history.replaceState(newState, 'Popup');
  }
};
